<template>
  <app-card class="flex flex-col is-borderless overflow-hidden">
    <div
      class="mb-12 relative"
      :class="{
        'bg-pattern-primary': !pending,
        'bg-pattern-grey': pending
      }"
    >
      <app-badge
        v-if="pending"
        icon="user-circle"
        class="mt-4 ml-4 absolute pin-t pin-l"
      >
        Pending
      </app-badge>
      <slot name="card-header" />
      <div
        class="w-24 h-24 mx-auto text-white font-bold text-2xl mt-12 -mb-12 flex justify-center items-center border-4 border-white"
        :class="{
          'bg-primary-700': !pending,
          'bg-grey-700': pending
        }"
      >
        {{ initials }}
      </div>
    </div>
    <div class="pt-3 pb-6 px-4 text-center leading-normal">
      <h2 class="text-base">
        {{ user.name }}
      </h2>
      <p v-if="user.company" class="italic text-grey-600 text-xs">
        {{ user.company.name | sentencecase }}
      </p>
      <p v-if="pending" class="italic text-grey-600 text-xs">
        Invitation Pending
      </p>
    </div>
  </app-card>
</template>

<script>
export default {
  name: "UserCard",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    initials() {
      if (!this.user.name) return false;
      const split = this.user.name.split(" ");
      let initial = split[0][0];
      return split[1] ? initial + split[1][0] : initial;
    },
    pending() {
      return !this.user.email_verified_at;
    }
  }
};
</script>
